export default __webpack_public_path__ + "052129f4a901cdb86cd11aa186ba51e6.png";